export default "__VITE_ASSET__0a934c3f__"